import Image from 'next/image';
import {FC} from 'react';
import { IMGPW } from '@/config';

interface CTA {
  title: string;
  url: string;
  target?: '_blank' | '_self';
}
interface Props {
  title: string;
  subtitle: string;
  paragraph: string;
  imgSrc: string;
  maxHeight?: number;
  buttonId?: string;
  cta?: CTA;
}

const BusinessIndexHeader: FC<Props> = (props) => {
  return (
    <div className="section-container my-5 mb-12">
      <div className="flex gap-12 flex-wrap items-stretch">
        <div className="flex-1">
          <h5
            className="mb-2 font-bold text-primary text-lg">
            {props.title}
          </h5>
          <h1 className="font-bold">
            {props.subtitle}
          </h1>
          <h6 className="text-justify mb-3">{props.paragraph}</h6>
          {props.cta && (
            <a
              id={props.buttonId}
              className="mt-2 button btn-primary btn-md leading-10"
              href={props.cta.url}
              rel="nofollow"
              target={props.cta.target ?? '_blank'}
            >
              {props.cta.title}
            </a>
          )}
        </div>
        <div className="flex-none w-full md:w-5/12 text-center relative aspect-video">
          <Image
            fill
            style={{
              borderRadius: '20px',
              objectFit: 'cover',
            }}
            alt={props.title}
            src={props.imgSrc}
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessIndexHeader;
